import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import CreateNewEntiry from './AddNew';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Slide from '@material-ui/core/Slide';

const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.primary.main[500],
  },
  boardContainer: {
    backgroundColor: '#7d23c18c',
    // display:'flex',
    // flexDirection: 'row'
  },
}))(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle
      disableTypography
      className={[classes.root, classes.boardContainer].join('')}
      style={{ backgroundColor: '#7d23c18c' }}
    >
      <Typography variant="h5" component="h5" style={{ color: '#fff' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
}))(MuiDialogContent);

const Transition = props => {
  return <Slide direction="up" {...props} />;
};
const styles = theme => ({
  fab: {
    margin: theme.spacing.unit,
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '55px',
    height: '55px',
    bottom: '20px',
    right: '20px',
    backgroundColor: '#4410a5d6',
    color: '#FFF',
    borderRadius: '50px',
    textAlign: 'center',
    cursor: 'pointer',
    fontSize: '70px',
    zIndex: '10',
  },
});

class CreateNewStuffs extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'md',
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Fab color="primary" aria-label="Add" className={classes.fab}>
          <AddIcon onClick={this.handleClickOpen} />
        </Fab>
        <Dialog
          fullWidth
          TransitionComponent={Transition}
          onClose={this.handleClose}
          aria-labelledby="customized-dialog-title"
          open={this.state.open}
          style={{ backgroundColor: '#7d23c18c' }}
        >
          <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
            Add New
          </DialogTitle>
          <DialogContent style={{ backgroundColor: '#7d23c18c' }}>
            <CreateNewEntiry />
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(CreateNewStuffs);
